import script from "./CarouselComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselComponent.vue?vue&type=script&setup=true&lang=js"

import "./CarouselComponent.vue?vue&type=style&index=0&id=7427e5ad&lang=css"

const __exports__ = script;

export default __exports__